export default {
  computed: {
    organization() {
      return this.$store && this.$store.getters['user/organization']
    },
    user() {
      return this.$store && this.$store.state.user.info
    },
    tbcMode() {
      return this.$store && this.$store.state.tbcMode
    },
    embedMode() {
      return window.top !== window.self
    }
  },
  methods: {
    canDo(permission) {
      return this.organization && this.organization.permissions && this.organization.permissions.indexOf(permission) >= 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/session.global.js